import type { ApiClient } from "./client";

export interface User {
  id: string;
  email: string;
  email_verified: boolean;
  locale: string;
  created_at: string;
}

export interface SignUpRequest {
  email: string;
  password: string;
  name?: string;
  locale?: "id" | "en";
}

export interface SignInRequest {
  email: string;
  password: string;
}

export const authApi = (client: ApiClient) => ({
  signUp: (req: SignUpRequest) => client.post<User>("/api/v1/auth/sign-up", req),
  signIn: (req: SignInRequest) => client.post<User>("/api/v1/auth/sign-in", req),
  signOut: () => client.post<void>("/api/v1/auth/sign-out"),
  verifyEmail: (token: string) => client.post<void>("/api/v1/auth/verify-email", { token }),
  forgotPassword: (email: string) => client.post<void>("/api/v1/auth/forgot-password", { email }),
  resetPassword: (token: string, password: string) =>
    client.post<void>("/api/v1/auth/reset-password", { token, password }),
  me: () => client.get<User>("/api/v1/auth/me"),
});
